var render = function render(){var _vm=this,_c=_vm._self._c;return _c('th',[_c('span',{staticClass:"text-muted",class:_vm.sort != null ? 'list-sort' : '',on:{"click":function($event){_vm.sort != null ? _vm.changeOrder(_vm.sort) : ''}}},[_vm._v(" "+_vm._s(_vm.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }